'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _markupMain_controller = require('./markup/main_controller');

var _markupMain_controller2 = _interopRequireDefault(_markupMain_controller);

var _beatportControllerTop_chart_controller = require('./beatport/controller/top_chart_controller');

var _beatportControllerTop_chart_controller2 = _interopRequireDefault(_beatportControllerTop_chart_controller);

var _markupGenres_nav_controller = require('./markup/genres_nav_controller');

var _markupGenres_nav_controller2 = _interopRequireDefault(_markupGenres_nav_controller);

var _markupPlayer_controls_controller = require('./markup/player_controls_controller');

var _markupPlayer_controls_controller2 = _interopRequireDefault(_markupPlayer_controls_controller);

var moduleName = 'app.controllers';

_angular2['default'].module(moduleName, []).controller('MainController', _markupMain_controller2['default']).controller('TopChartController', _beatportControllerTop_chart_controller2['default']).controller('PlayerControlsController', _markupPlayer_controls_controller2['default']).controller('GenresNavController', _markupGenres_nav_controller2['default']);

exports['default'] = moduleName;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./resources/assets/js/src/modules/app.controllers.js
 ** module id = 36
 ** module chunks = 0
 **/